import { useMemo } from 'react';
import { useListItemContext } from './list-item-provider';
export function useNestedList() {
  var _useListItemContext;
  const {
    nextPaddingStart
  } = (_useListItemContext = useListItemContext()) != null ? _useListItemContext : {};
  return useMemo(() => {
    const currentPaddingStart = nextPaddingStart != null ? nextPaddingStart : 0;
    return {
      currentPaddingStart,
      nextPaddingStart: currentPaddingStart + 1
    };
  }, [nextPaddingStart]);
}